import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ActivityStoreFacade } from '../../../common/facade/ActivityStoreFacade';
import { ActivatedRoute} from '@angular/router';
import { Router } from '@angular/router';
import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';

@Component({
    selector: 'app-reportstorepriceadvance',
    templateUrl: './reportstorepriceadvance.component.html'
})

export class ReportStorePriceAdvanceComponent
    implements OnInit {

    // Properties and Attributes
    lblSearch = res.Search;
    lblStyleVariety = res.StyleVariety;
    lblDescription = res.Description;
    lblPrice = res.Price;
    lblCompletedDate = res.CompletedDate;

    @ViewChild('tableChanges') tableChanges: DatatableComponent;

    loading = false;
    messageLoader = '';
    message = '';
    modalTitle = '';
    rows: any = [];
    private _filteredData = [];
    private _activStoreId = 0;
    private _sectionId = 0;
    private _genderId = 0;

    // alert
    alerts: any[] = [];

    // Constructor
    constructor(
        private _facade: ActivityStoreFacade,
        private route: ActivatedRoute,
        private _router: Router,
        public strings: Strings
    ) {
    }

    // EventHandlers
    ngOnInit() {
        const navigation = this.route.queryParams.subscribe(params => {
            this._activStoreId = Number(params['pActvStrd']);
            this._sectionId = Number(params['pSecId']);
            this._genderId = Number(params['pGendId']);
          });

        this.loading = true;
        this.messageLoader = this.strings.GetText(res.Loading);
        this._facade.GetPriceAdvance(this._activStoreId, this._sectionId, this._genderId).subscribe(result => {
            if (result.completed) {
                this.rows = result.data;
                this._filteredData = result.data;
            }

            this.loading = false;
        }, error => {
            this.addAlert('<strong>' + error + '</strong>', 'danger');
            this.loading = false;
        });
    }

    updateFilter(event) {
        const val = event.target.value.toLowerCase();

        const keys = Object.keys(this._filteredData[0]);
        this.rows = this._filteredData.filter(function (item) {
            for (let i = 0; i < keys.length; i++) {

                if (item[keys[i]] != null &&
                    (item[keys[i]].toString().toLowerCase().indexOf(val) !== -1 || !val)) {
                    return true;
                }
            }
        });

        this.tableChanges.offset = 0;
    }

    // añadir alert
    addAlert(message: String, type: String): void {
        this.alerts = [];
        this.alerts.push({
            type: type,
            msg: message
        });
    }

    // cerrar alert
    onClosed(dismissedAlert: AlertComponent): void {
        this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
    }
}
